import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  controls: {
    display: 'flex',
    gap: 20
  }
}))
